var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormField, FormGrid, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { HookFormText } from 'components/hookForm';
import { notificationActions } from 'components/notifications/actions/notification';
import { createAppModal } from 'utils/modal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import styles from './flowModal.module.scss';
import { modalTitle } from './util/helper';
import { useUpdateFlow } from './util/useUpdateFlow';
const formId = 'flow-form';
/** A modal for updating flows. */
export const FlowModal = createAppModal({ type: 'settings:flow' }, ({ isOpen, modal, meta, hide }) => {
    const { flow, mode = 'rename' } = modal.arg;
    const form = useForm({
        mode: 'all',
        defaultValues: {
            name: flow.name,
        },
    });
    const updateFlow = useUpdateFlow();
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const handleValidSubmit = (values) => {
        setIsLoading(true);
        if (mode === 'rename') {
            handleRenameFlow(values);
        }
    };
    const handleRenameFlow = ({ name }) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield updateFlow({ flow: { name }, id: flow.id });
            dispatch(notificationActions.notificationAdd({
                title: 'Flow updated',
                text: `"${name}" flow has been updated`,
                icon: 'i-done',
                className: 'success',
                time: 5000,
            }));
            meta === null || meta === void 0 ? void 0 : meta.resolve({ isConfirmed: true, isCancelled: false });
            hide === null || hide === void 0 ? void 0 : hide();
        }
        catch (error) {
            console.warn(error);
            dispatch(notificationActions.notificationAdd({
                title: 'An error occurred',
                text: `An error occurred when trying to update the "${name}" flow`,
                className: 'danger',
                icon: 'i-exclamation',
            }));
            setIsLoading(false);
        }
    });
    return (_jsxs(Modal, Object.assign({ className: styles.root, isOpen: isOpen, onClose: hide }, { children: [_jsx(ModalHead, { title: modalTitle[mode], onClose: hide }), _jsx(ModalBody, { children: _jsx("form", Object.assign({ id: formId, onSubmit: form.handleSubmit(handleValidSubmit) }, { children: _jsx(FormGrid, { children: _jsx(FormField, { children: _jsx(HookFormText, { name: "name", label: "Name", control: form.control, rules: {
                                    required: 'Name is required',
                                } }) }) }) })) }), _jsx(ModalFoot, { cancelOnClick: hide, confirmName: "Update", confirmOnClick: form.handleSubmit(handleValidSubmit), confirmProps: {
                    type: 'submit',
                    form: formId,
                    disabled: !form.formState.isDirty || !form.formState.isValid,
                    isLoading,
                } })] })));
});
